import React from "react"
import Select from "react-select"

const SearchTypeDropdown = ({
  selectOptions,
  searchTypeVal,
  handleChange,
  menuIsOpen,
  classNameWrapper,
  className,
}) => {
  // console.log("searchTypeVal ==>", searchTypeVal, SearchType[searchTypeVal])
  return (
    <div className={`select-option dropdown ${classNameWrapper}`}>
      <Select
        options={selectOptions}
        placeholder="For Sale"
        className={`react-select ${className}`}
        classNamePrefix="react-select"
        onChange={(event) => handleChange(event.value)}
        value={selectOptions.filter((item) => item.value === searchTypeVal)}
        menuIsOpen={menuIsOpen}
      />
    </div>
  )
}
export default SearchTypeDropdown
